import { Box, Button, Grid, Typography, TextField } from '@mui/material';
import { useState } from 'react';
import { gridSpacing } from 'app/constant';
import { deepPurple } from '@mui/material/colors';

const FilterTasklist = ({ tasklistFilterIsLoading, setTasklistFilterIsLoading, fetchTaskList }) => {
    // Filter tasklist related
    const [filterTaskValueRangeStart, setFilterTaskValueRangeStart] = useState(0);
    const [filterTaskValueRangeEnd, setFilterTaskValueRangeEnd] = useState(0);

    const handleTasklistFilter = () => {
        setTasklistFilterIsLoading(true);
        fetchTaskList(filterTaskValueRangeStart, filterTaskValueRangeEnd).then(() => {
            setTasklistFilterIsLoading(false);
        });
    };

    return (
        <>
            <Typography sx={{ padding: '25px 0px' }} id="modal-modal-title" variant="h3" component="h2">
                Filter Tasklist
            </Typography>
            <Grid item container xs={12} spacing={gridSpacing} sx={{ marginBottom: '10px', overflowY: 'auto' }}>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Task Value Range Start :
                        </Typography>
                        <TextField
                            type="number"
                            id="outlined-basic"
                            variant="outlined"
                            value={filterTaskValueRangeStart}
                            onChange={(e) => setFilterTaskValueRangeStart(e.target.value)}
                        />
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Task Value Range End :
                        </Typography>
                        <TextField
                            type="number"
                            id="outlined-basic"
                            variant="outlined"
                            value={filterTaskValueRangeEnd}
                            onChange={(e) => setFilterTaskValueRangeEnd(e.target.value)}
                        />
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={4}>
                    <Button
                        variant="contained"
                        sx={{
                            float: 'right',
                            display: 'block',
                            mx: 'auto',
                            width: '150px',
                            backgroundColor: deepPurple[500],
                            marginTop: '20px',
                            marginBottom: '30px'
                        }}
                        onClick={handleTasklistFilter}
                        disabled={tasklistFilterIsLoading}
                    >
                        Filter
                    </Button>
                </Grid>
            </Grid>
        </>
    );
};

export default FilterTasklist;
